'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkA11YIssues = checkA11YIssues;
exports.initDisclosure = initDisclosure;
exports.initDisclosures = initDisclosures;

var _keyMappings = require('@fr/key-mappings');

/**
 * A disclosure is a button that controls visibility of a section of content.
 * When the controlled content is hidden, it is often styled as a typical push
 * button with a right-pointing arrow or triangle to hint that activating the
 * button will display additional content. When the content is visible, the
 * arrow or triangle typically points down.
 *
 * It follows practice stated at
 * https://www.w3.org/TR/wai-aria-practices-1.1/#disclosure
 */

/**
 * Toggles the disclosure related to the given control.
 *
 * @param {object} control Control that controls the disclosure content.
 * @param {object} event   Event that needs the be caught for the toggling.
 */
var toggleExpandDisclosure = function toggleExpandDisclosure(control, event) {

  var content = document.querySelector('#' + control.getAttribute('aria-controls')),
      expanded = control.getAttribute("aria-expanded") === "true" || false;

  event.preventDefault();
  event.stopPropagation();

  control.setAttribute('aria-expanded', !expanded);
  content.hidden = !content.hidden;
};

/**
 * Checks for accessibility issue in the disclosure markup related to the given
 * control.
 *
 * @param {object} control The control of the disclosure under check.
 */
function checkA11YIssues(control) {

  var role = control.getAttribute('role'),
      ariaExpanded = control.getAttribute('aria-expanded'),
      tabindex = control.getAttribute('tabindex'),
      ariaControls = control.getAttribute('aria-controls');

  if (role === null || role.toLowerCase() !== 'button') {
    throw new Error('Disclosure `role` should be `button`');
  } else if (tabindex === null || tabindex !== '0') {
    throw new Error('Disclosure control `tabindex` not set appropriately');
  } else if (ariaExpanded === null) {
    throw new Error('Disclosure `aria-expanded` attribute should be set');
  } else if (ariaControls === null) {
    throw new Error('Disclosure `aria-controls` attribute should be set');
  } else {

    var content = document.querySelector('#' + control.getAttribute('aria-controls'));

    if (content === null) {
      throw new Error('Disclosure controlled content does not exists');
    }
  }
};

/**
 * Inits the disclosure related to the given control.
 *
 * @param {object} control Control of a disclosure.
 */
function initDisclosure(control) {

  var content = document.querySelector('#' + control.getAttribute('aria-controls'));

  // a11y checks just in browser mode.
  if (navigator && navigator.userAgent !== 'node.js') {
    try {
      checkA11YIssues(control);
    } catch (e) {
      console.error(control.outerHTML + ' fails accessibility checks. Reason: ' + e.message);
    }
  }

  // Makes content hidden onload.
  control.setAttribute('aria-expanded', false);
  content.hidden = true;

  // Mouse interaction.
  control.addEventListener('click', function (event) {
    toggleExpandDisclosure(this, event);
  });

  // Keyboard interaction.
  control.addEventListener('keydown', function (event) {
    if (event.keyCode === _keyMappings.SPACE_KEY || event.keyCode === _keyMappings.ENTER_KEY) {
      toggleExpandDisclosure(this, event);
    }
  });
};

/**
 * Inits the disclosures present in the document.
 *
 * @param {object} control Control of a disclosure.
 */
function initDisclosures() {

  var disclosureControls = document.querySelectorAll('.js-disclosure-control');

  // Setups every disclosure element.
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = disclosureControls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var control = _step.value;

      initDisclosure(control);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};